import type { CardContentKind } from "#card-content";

/**
 * Whether a card counts in forecast and inventory stats: the Upcoming forecast, stage counts and
 * the Stats tab's totals. A quiz card checks a lesson's teaching rather than a character or word
 * the learner studies, and learners read those stats as being about their characters, so quizzes
 * stay out unless the synced "Show quiz cards in stats" setting is on. Due counts and review
 * activity (streak, heatmap, daily reviews, Han) always include them: those are real reviews.
 *
 * A card whose overlay has not synced yet (`null`) counts, as it always has.
 */
export function isCardContentKindCountedInStats(
  cardContentKind: CardContentKind | null,
  user: { isQuizCardsInStatsEnabled?: boolean | null } | null | undefined,
): boolean {
  return cardContentKind !== "quiz" || user?.isQuizCardsInStatsEnabled === true;
}
